import ThankYou from '../views/ThankYou'

export default {
  path: '/thank-you',
  name: 'thank-you',
  component: ThankYou
}
